import routes from './routes'
import store from './store'

export default {
    name: 'm-cache',
    store: store,
    routes: routes
}